import * as React from 'react';
import { FaChevronDown } from 'react-icons/fa6';
import { Spinner } from '../Spinner/Spinner';
import "./Dropdown.scss";
import { DropdownHeader } from './Components/Dropdown.Header';
import { DropdownContent } from './Components/Dropdown.Content';
import { useOutsideClick } from '../Hooks/useOutsideClick';
import { SelectableOption } from '../Shared/Shared';







export interface DropdownProps {
  name?: string
  options?: SelectableOption[]
  value?: any
  className?: string
  optionSelected?(option: SelectableOption, name?: string): void
  onChange?(event: { target: { name: string, value: any } }): void
  onSet?(value: any, name?: string): void // Used for state setters
  isLoading?: boolean
  // onFocus?()
  // onBlur?()
  // onReturn?()
  // allowNull?:boolean
  // nullTitle?:string
  disableEditing?: boolean
  showSearch?: boolean
  placeholder?: string
  stayAtTopOnOpen?: boolean
  stayOpenOnSelect?: boolean
  maxOpenHeight?: number
  float?: boolean // MAke it so this floats over it's content.
}
interface State {
  isOpen: boolean,
  searchQuery: string
}



function heightForItems(items?: SelectableOption[], showSearch?: boolean) {
  let height = 32;
  if (showSearch) {
    height += 48;
  }
  if (items) {
    items.forEach(item => {
      if (item.isDivider) {
        height += 16;
      } else if (item.isHeading) {
        height += 32;
      } else {
        height += 32;
      }
    })
  }


  return height;
}


export function Dropdown(props: DropdownProps) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const { options, value, name, optionSelected, onChange, stayOpenOnSelect, showSearch, placeholder, disableEditing, onSet, float } = props

  const handleClickOutside = () => { setIsOpen(false) };
  const ref = useOutsideClick(handleClickOutside);

  const items = searchQuery.length ? options?.filter(item => item.label?.toLowerCase().includes(searchQuery.toLowerCase())) : options;
  const openHeight = Math.min(props.maxOpenHeight || 336, heightForItems(items, showSearch));
  const style = (isOpen) ? { height: openHeight + "px" } : { height: "32px" }

  const close = () => { setIsOpen(false) } // Making these explicite in case i need to modify them.
  const open = () => { setIsOpen(true) }
  const toggleOpen = () => { isOpen ? close() : open() }

  const itemSelected = (item: SelectableOption) => {
    if (onChange) { onChange({ target: { name: name!, value: item.value } }) }
    if (onSet) { onSet(item.value, name) }
    if (optionSelected) { optionSelected(item, name) }
    if (stayOpenOnSelect) { return; }
    close();
  }
  let className = props.className || ""
  className += ` ${isOpen ? "Dropdown isOpen" : "Dropdown isClosed"} ${disableEditing ? "editingDisabled" : ""}  ${float ? "float" : ""}`;
  return <div className={className} style={style} ref={ref}>
    <DropdownHeader
      isLoading={props.isLoading}
      options={items}
      value={value}
      placeholder={placeholder}
      onClick={toggleOpen}
      disableEditing={disableEditing}
    />
    {!disableEditing && <DropdownContent
      options={items}
      openHeight={openHeight}
      showSearch={showSearch || false}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      itemSelected={itemSelected}
    />
    }
  </div>
}
